export const downloadCSV = (
  headers: string[],
  records: any[],
  outputtedRows: (record: any) => string[],
  filename = `records-${new Date().toISOString().split('T')[0]}.csv`,
) => {
  const escapeCsvValue = (value: unknown): string => {
    const raw =
      value === null ||
      value === undefined ||
      String(value).toLowerCase() === 'null'
        ? ''
        : String(value);
    const needsQuoting = /[",\n\r]/.test(raw);
    const escaped = raw.replace(/"/g, '""');
    return needsQuoting ? `"${escaped}"` : escaped;
  };

  const rows = records
    .filter(row => row !== undefined)
    .map(record => outputtedRows(record).map(escapeCsvValue)); // Replace null/undefined and escape values

  const escapedHeaders = headers.map(h =>
    /[",\n\r]/.test(h) ? `"${h.replace(/"/g, '""')}"` : h,
  );
  let csvContent = `${escapedHeaders.join(',')}\n`;
  rows.forEach(rowArray => {
    const row = rowArray.join(',');
    csvContent += `${row}\n`;
  });

  const encodedUri = `data:text/csv;charset=utf-8,${encodeURIComponent(
    csvContent,
  )}`;
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
